import { render } from "./Statistics.vue?vue&type=template&id=7ad2dc81&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=7ad2dc81&scoped=true&lang=css"
import "./Statistics.vue?vue&type=style&index=1&id=7ad2dc81&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad2dc81"]])

export default __exports__